'use client';

import React from 'react';
import { TableFAQ } from 'components/shared';
import { useTranslations } from 'next-intl';
import { getLesMillsContent } from './content';

const FAQ = () => {
  const t = useTranslations('uhXLesMills');
  const { faqItems } = React.useMemo(() => getLesMillsContent(t), [t]);

  return (
    <TableFAQ
      title={t('faq.heading')}
      faqItems={faqItems}
      bgColor="white"
    />
  );
};

export default FAQ;
